module.exports = __webpack_public_path__ + "img/11.505f2a56.png";